import { useMutation } from 'react-query';
import { educationServices } from 'services/cv';

import UseToast from 'hooks/use-toast';
import UseModal from 'hooks/use-modal';
import Modal from '@core/components/Modal/Modal';

import LinkButton from '@core/components/linkbutton/LinkButton';
import ActionButton from '@core/components/actionbutton/ActionButton';

import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';

import EditIcon from 'assets/icons/edit-icon-filled.svg?url';
import AddIcon from 'assets/icons/add-square-icon.svg?url';
import DeleteIcon from 'assets/icons/trash-icon.svg?url';
import { BookSaved } from 'iconsax-react';

import classes from './Educations.module.scss';

const Educations = ({ data, refetchMyResume, hasEditButton = false, editClickHandler, isNewStep = true }) => {
	const { destroyModal, show, showModal } = UseModal();
	const { ToastContainer, toast } = UseToast();

	const { mutate: deleteEducations } = useMutation(educationServices.DELETE, {
		onSuccess: () => {
			refetchMyResume();
			toast('Education deleted successfully');
		},
		onError: () => {
			toast('Something went wrong! please try again.');
		}
	});

	const deleteEducationHandler = (id) => {
		deleteEducations(id);
	};

	return (
		<>
			<ToastContainer />
			{((data && data.education?.length > 0) || isNewStep) && (
				<section className={`d-flex flex-column gap-2 ${classes['education-wrapper']}`}>
					<div
						className={`d-flex flex-row justify-content-between ${classes['education-title']}`}>
						<div className='d-flex align-items-center gap-2 ms-4'>
							<BookSaved />
							<h4 className="d-none d-md-block">Education</h4>
						</div>
						{hasEditButton &&
							<div className="d-flex gap-1">
								<ActionButton kind="simple" onClick={() => editClickHandler('education_new')}>
									<img src={AddIcon} alt="add-icon" />
								</ActionButton>
								<ActionButton kind="simple" onClick={() => editClickHandler('education')}>
									<img src={EditIcon} alt="edit-icon" />
								</ActionButton>
							</div>
						}
					</div>
					<div className={`d-flex flex-column gap-4 ${classes['education-content']}`}>
						<>
							{data?.education?.map((edu) => {
								return (
									<div
										key={edu.id}
										className={`d-flex flex-column flex-md-row justify-content-between align-items-baseline align-items-md-center ${classes['education-card']}`}>
										<div className="d-flex flex-column gap-2 order-2 order-md-1">
											<h6>{edu.university}</h6>
											<p>{edu.field_or_major}</p>
										</div>
										{edu.is_currently_student && (
											<span className="order-1 order-md-2 align-self-end align-self-md-center">
												Student
											</span>
										)}
									</div>
								);
							})}
						</>
					</div>
				</section>
			)}
			<Modal
				title={'Edit Educations'}
				show={show}
				closeHandler={destroyModal}
				type={MOBILE_SLIDE_UP}>
				<div className={`d-flex flex-column gap-4 ${classes['education-content-modal']}`}>
					{data?.education?.map((edu) => {
						return (
							<div
								key={edu.id}
								className={`d-flex flex-column flex-md-row justify-content-between ${classes['education-card-modal']}`}>
								<div
									className={`order-2 order-md-1 d-flex flex-column flex-md-row justify-content-between align-items-baseline align-items-md-center flex-grow-1  ${classes['education-card-modal_content']}`}>
									<div className={`d-flex flex-column gap-2 order-2 order-md-1`}>
										<h6>{edu.university}</h6>
										<p>{edu.field_or_major}</p>
									</div>
									{edu.is_currently_student && (
										<span className="order-1 order-md-2 align-self-end align-self-md-center">
											Student
										</span>
									)}
								</div>
								<div
									className={`order-1 order-md-2 d-flex flex-row align-self-end align-self-md-center ${classes['education-card-modal_actions']}`}>
									<ActionButton kind="simple" onClick={() => deleteEducationHandler(edu.id)}>
										<img src={DeleteIcon} alt="delete-icon" />
									</ActionButton>
									<LinkButton kind="simple" to={`/profile/my-resume/education/${edu.id}`}>
										<img src={EditIcon} alt="edit-icon" />
									</LinkButton>
								</div>
							</div>
						);
					})}
					<LinkButton to={`/profile/my-resume/education/new`}>
						+ Add another Education
					</LinkButton>
				</div>
			</Modal>
		</>
	);
};

export default Educations;
